import React, { useState } from 'react';
import { Toolbar, Paper, Button, Grid, Typography } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import SideMenu from '../../components/SideMenu';
import Alert from '../../components/Alert';
import Input from '../../components/Input';
import { ListPageHeading } from '../../components/ListPageLayout';

import api from '../../services/api';

export default function PersonTypeCreate() {
    const classes = useStyles();

    const initialValues = {
        name: '',
    };

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const saveFunc = async (values, formik) => {
        try {

            const personTypeData = {
                ...values,
            };
            const result = await api.post('/person_type/create', personTypeData);
            const { personType } = result.data;

            formik.setSubmitting(false);

            setMessage({
                open: true,
                variant: 'success',
                text: `Tipo de pessoa "${personType.name}" cadastrado com sucesso!`,
            });
            resetForm(formik);
        }
        catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    const resetForm = formik => {
        formik.resetForm();
    };

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3} className={classes.pageGrid}>
                    <Grid item xs={12}>
                        <ListPageHeading icon="person" title="Novo tipo de pessoa" />
                    </Grid>
                    <Formik
                        initialValues={initialValues}
                        onSubmit={saveFunc}
                    >
                        {({ values, handleChange, handleSubmit, isSubmitting }) => (
                            <Grid item xs={12}>
                                <Paper elevation={0} className={classes.formCard}>
                                    <div className={classes.cardHeader}>
                                        {/*<div className={classes.cardHeaderIcon}>
                                            <AssignmentIndOutlinedIcon />
                                        </div>*/}
                                        <div>
                                            <Typography className={classes.cardTitle}>
                                                Informações do tipo de pessoa
                                            </Typography>
                                            {/*<Typography className={classes.cardSubtitle}>
                                                Defina como este grupo de pessoas será identificado no sistema.
                                            </Typography>*/}
                                        </div>
                                    </div>

                                    <form id="person-type-create" onSubmit={handleSubmit} className={classes.form}>
                                        <div className={classes.formBody}>
                                            {/*<div className={classes.infoBanner}>
                                                <InfoOutlinedIcon />
                                                <Typography>
                                                    Utilize um nome claro e objetivo para facilitar buscas, filtros e cadastros.
                                                </Typography>
                                            </div>*/}

                                            <div className={classes.fieldSection}>
                                                <Typography className={classes.fieldSectionTitle}>
                                                    Identificação
                                                </Typography>
                                                <Typography className={classes.fieldSectionDescription}>
                                                    Defina um nome para o novo tipo de pessoa.
                                                </Typography>

                                                <div className={classes.nameField}>
                                                    <Input
                                                        label="Nome"
                                                        textFieldProps={{
                                                            name: 'name',
                                                            id: 'person-type-name',
                                                            placeholder: 'Ex.: Funcionário, visitante ou prestador',
                                                            onChange: handleChange,
                                                            value: values.name,
                                                            fullWidth: true,
                                                            required: true,
                                                        }}
                                                    />
                                                    {<Typography className={classes.fieldHint}>
                                                        Campo obrigatório
                                                    </Typography>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className={classes.formActions}>
                                            <Button
                                                disabled={isSubmitting}
                                                type="submit"
                                                variant="contained"
                                                form="person-type-create"
                                                color="primary"
                                                endIcon={<SaveIcon />}
                                                id="salvar"
                                                className={classes.button}
                                            >
                                                {isSubmitting ? 'Salvando...' : 'Salvar tipo de pessoa'}
                                            </Button>
                                        </div>
                                    </form>
                                </Paper>
                            </Grid>
                        )}
                    </Formik>
                </Grid>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}
            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    content: {
        flexGrow: 1,
        minWidth: 0,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    pageGrid: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 960,
    },
    formCard: {
        backgroundColor: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 16,
        boxShadow: '0 10px 30px rgba(15, 23, 42, .05)',
        overflow: 'hidden',
    },
    cardHeader: {
        alignItems: 'center',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2.5, 3),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'flex-start',
            padding: theme.spacing(2),
        },
    },
    cardHeaderIcon: {
        alignItems: 'center',
        backgroundColor: '#e3f2fd',
        borderRadius: 10,
        color: '#1976d2',
        display: 'flex',
        flexShrink: 0,
        height: 40,
        justifyContent: 'center',
        width: 40,
        '& svg': {
            fontSize: 21,
        },
    },
    cardTitle: {
        color: '#1e293b',
        fontSize: '1rem',
        fontWeight: 700,
    },
    cardSubtitle: {
        color: '#64748b',
        fontSize: '.82rem',
        lineHeight: 1.45,
        marginTop: 2,
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formBody: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    infoBanner: {
        alignItems: 'flex-start',
        background: 'linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%)',
        border: '1px solid #dbeafe',
        borderRadius: 12,
        color: '#64748b',
        display: 'flex',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2.5),
        padding: theme.spacing(1.5),
        '& svg': {
            color: '#1976d2',
            flexShrink: 0,
            fontSize: 20,
            marginTop: 1,
        },
        '& p': {
            fontSize: '.82rem',
            lineHeight: 1.5,
        },
    },
    fieldSection: {
        backgroundColor: '#fbfdff',
        border: '1px solid #e2e8f0',
        borderRadius: 14,
        padding: theme.spacing(2),
    },
    fieldSectionTitle: {
        color: '#1e293b',
        fontSize: '.95rem',
        fontWeight: 700,
    },
    fieldSectionDescription: {
        color: '#64748b',
        fontSize: '.78rem',
        lineHeight: 1.4,
        marginTop: 1,
    },
    nameField: {
        marginTop: theme.spacing(2),
        maxWidth: 600,
        '& .MuiTextField-root': {
            width: '100%',
        },
    },
    fieldHint: {
        color: '#94a3b8',
        fontSize: '.7rem',
        marginLeft: theme.spacing(.25),
        marginTop: theme.spacing(.5),
    },
    formActions: {
        alignItems: 'center',
        backgroundColor: '#fff',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(2, 3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.5, 2),
        },
    },
    button: {
        borderRadius: 9,
        boxShadow: '0 6px 14px rgba(25, 118, 210, .2)',
        fontWeight: 700,
        minHeight: 42,
        minWidth: 210,
        textTransform: 'none',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
}));
